$(document).ready(function () {

    $(".overlay-show-by-suc").hide()
    $(".overlay-export-stock").hide()
    $('#table-stock').DataTable({
        "paging": true,
        "deferRender": true,
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json",
            "processing": "Buscando registro(s) ..."
        },
    });
    let data = new FormData

    $("#form-show-by-sucursal").on('submit', function (e) {
        e.preventDefault()
        let datos = $('#form-show-by-sucursal').serialize()
        data.append('data', datos)
        sendData('view-stock-by-suc', data)
    })

    $("#export-stock").on('click', function (e) {
        e.preventDefault()
        $(".overlay-export-stock").show()
        $.ajax({
            url: '/export-stock',
            type: "GET",
            processData: false,
            contentType: false,
            xhrFields: {
                responseType: 'blob',
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (result, status, xhr) {
                var disposition = xhr.getResponseHeader('content-disposition');
                var matches = /"([^"]*)"/.exec(disposition);
                var filename = (matches != null && matches[1] ? matches[1] : 'reporte_stock_' + getDate() + '.xlsx');

                // The actual download
                var blob = new Blob([result], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                alertWithBtn('La descarga ha finalizado.')
                $(".overlay-export-stock").hide()
            }
        }).fail(function () {
            $(".overlay-export-stock").hide()
        })
    })

    $('#select_sucursal_name').on('change', function (e) {
        // let table = $('#table-stock').DataTable();
        // table.clear().draw();
        // table.destroy();
    })

    // $("#form-get-stock-by-suc").on('submit', function (e) {
    //     e.preventDefault()
    //     let sucursal_name = $("#select_sucursal_name option:selected").text();
    //     $('#table-stock').DataTable({
    //         "processing": true,
    //         "serverSide": true,
    //         type: "GET",
    //         headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    //         ajax: '/abastecimiento/existencias/stock-sucursal/' + sucursal_name,
    //         "columns": [
    //             {data: 'Itemcode'},
    //             {data: 'ItemName'},
    //             {data: 'OnHand'},
    //         ],
    //         "columnDefs": [
    //             {
    //                 "targets": 2,
    //                 "render": function (data, type, row, meta) {
    //                     console.log(row)
    //                     console.log("Aqu")
    //                 }
    //             }],
    //         "language": {
    //             "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json",
    //             "processing": "Buscando registro(s) ..."
    //         },
    //     });
    // })


    function getDate() {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (month < 10) {
            return `${day}-0${month}-${year}`;

        } else {
            return `${day}-${month}-${year}`;
        }
    }
})
